// Claude: 2-tab layout — Plan + Statement 25-Apr-2026
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  VStack,
  Link,
} from "@chakra-ui/react";
import { Images } from "../../Assets/images";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import FAQModal from "../../Components/Modals/FAQModal";
import { useSelector } from "react-redux";
import { SellerAPI } from "../../Apis/sellerAPI";
import { AdminAPI } from "../../Apis/adminAPI";
import Loader from "../../Components/Loader/Loader";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { MdArrowBack } from "react-icons/md";

type Props = {};

const TAB_PLAN = 0;
const TAB_STATEMENT = 1;

const Subscription = (_props: Props) => {
  const [isModal, setIsModal] = useState(false);
  const [activeTab, setActiveTab] = useState(TAB_PLAN);
  const [userPlan, setUserPlan] = useState<any>({});
  const [sellerData, setSellerData] = useState<any>(null);
  const [statements, setStatements] = useState<any[]>([]);
  const user = useSelector((state: any) => state.user);
  const { success, error } = useToastWrapper();

  const navigate = useNavigate();

  const getPlanDetails = async () => {
    try {
      const [profileRes, stmtRes] = await Promise.all([
        SellerAPI.getSellerProfile(),
        SellerAPI.getStatements(),
      ]);
      if (profileRes) {
        const seller = profileRes.data.data;
        setSellerData(seller);
        setUserPlan(seller);
      }
      setStatements(stmtRes?.data?.data ?? stmtRes?.data ?? []);
    } catch (err: any) {
      console.log(err);
    }
  };

  // Claude: pass companyName + planName so admin gets full context 28-03-2026
  const sendRenewRequest = async () => {
    try {
      const res = await AdminAPI.requestSellerSubscriptionPlan({
        sellerName: sellerData?.personName,
        companyName: sellerData?.companyName,
        planName: sellerData?.planName,
      });
      if (res) {
        success("Your renewal request has been sent. Our team will be in touch shortly.");
        navigate("/seller/seller-subscriptions-purchase");
      }
    } catch (err) {
      error("Failed to send renewal request. Please try again or contact support@aftr.network.");
    }
  };

  useEffect(() => { getPlanDetails(); }, []);

  const tabStyle = (active: boolean) => ({
    flex: 1,
    padding: "8px 0",
    textAlign: "center" as const,
    fontSize: "12px",
    fontWeight: active ? 700 : 400,
    color: active ? "#0E122F" : "#888",
    borderBottom: active ? "2px solid #0E122F" : "2px solid transparent",
    cursor: "pointer",
    background: "white",
  });

  return (
    <Box display="flex" flexDir="column" w="100%" minH="calc(100dvh + 85px)" pb="85px" bg="#F3F0FF">
      <Modal footer={null} title={null} open={isModal} onCancel={() => setIsModal(false)} closeIcon={null} onOk={() => setIsModal(false)}>
        <FAQModal handleCloseModal={() => setIsModal(false)} />
      </Modal>

      <Flex w="100%" px="30px" py={5} bg="#0E122F" color="white" alignItems="center" justifyContent="space-between">
        <Flex alignItems="center" gap={3} cursor="pointer" onClick={() => navigate(-1)}>
          <MdArrowBack size={20} color="white" />
          <Text fontSize="xl" fontWeight={700}>Subscription</Text>
        </Flex>
        <VStack spacing={0} alignItems="center" justifyContent="center">
          <Image src={Images.AftrLogo} h="32px" objectFit="contain" />
          <Text fontSize="11px" fontWeight={300} color="whiteAlpha.600" letterSpacing="wide">
            seller (beta)
          </Text>
        </VStack>
      </Flex>

      {/* Tabs */}
      <Flex bg="white" borderBottom="1px solid #eee">
        <div style={tabStyle(activeTab === TAB_PLAN)} onClick={() => setActiveTab(TAB_PLAN)}>Plan</div>
        <div style={tabStyle(activeTab === TAB_STATEMENT)} onClick={() => setActiveTab(TAB_STATEMENT)}>Statement</div>
      </Flex>

      {/* Plan Tab */}
      {activeTab === TAB_PLAN && (
        <>
          {sellerData && !userPlan?.planName ? (
            <Box px={5} pt={6}>
              <Text fontSize="sm" color="gray.600">
                You do not have any active subscriptions. Contact{" "}
                <Link href="mailto:support@aftr.com" color="blue.500">support@aftr.com</Link>
              </Text>
            </Box>
          ) : sellerData ? (
            <Box px={5} pt={5} pb={8}>
              <Box bg="white" borderRadius="14px" px={4} py={3} mb={3} shadow="sm" border="1px solid #E9E4FF">
                <Flex justifyContent="space-between" alignItems="center">
                  <Text fontSize="sm" fontWeight={700} color="#0E122F">{userPlan?.planName}</Text>
                  <Box px={3} py={1} borderRadius="full"
                    bg={userPlan?.isPlanActive ? "#F0FDF4" : "#FEF2F2"}
                    border={`1px solid ${userPlan?.isPlanActive ? "#86EFAC" : "#FCA5A5"}`}>
                    <Text fontSize="11px" fontWeight={600} color={userPlan?.isPlanActive ? "#166534" : "#991B1B"}>
                      {userPlan?.isPlanActive
                        ? "Active"
                        : userPlan?.subscriptionPlanId
                          ? "Plan limit reached. Renew subscription"
                          : "Inactive"}
                    </Text>
                  </Box>
                </Flex>
              </Box>

              <VStack spacing={2} align="stretch">
                {[
                  { label: "Buyer Inquiries Limit", count: userPlan?.rfxMatchedCountPerCycle, limit: userPlan?.rfxLimit, note: "The number of Buyer inquiries matched to you. When this limit is reached, no new inquiries are matched — but you can still respond to opportunities already in your list. Unused quota is not carried over on renewal." },
                ].map(({ label, count, limit, note }) => (
                  <Box key={label} bg="white" borderRadius="14px" px={4} py={3} shadow="sm" border="1px solid #E9E4FF">
                    <Flex justifyContent="space-between" alignItems="center" mb={1}>
                      <Text fontSize="13px" fontWeight={600} color="gray.700">{label}</Text>
                      <Text fontSize="13px" fontWeight={700} color="#7C66FF">
                        {count ?? 0} <Text as="span" fontWeight={400} color="gray.400">/ {limit ?? "—"}</Text>
                      </Text>
                    </Flex>
                    <Text fontSize="11px" color="gray.400">{note}</Text>
                  </Box>
                ))}
              </VStack>

              <Flex mt={5} justifyContent="space-between" alignItems="center">
                <Text fontSize="10px" color="gray.400" fontStyle="italic">
                  View <Link href="https://prontocommerce.com/aftr/subscriptions/" isExternal textDecoration="underline">T&Cs</Link>
                </Text>
                <Button size="sm" bg="#F3F0FF" color="#7C66FF" borderRadius="10px" px={5}
                  _hover={{ bg: "#E9E4FF" }} onClick={sendRenewRequest}>
                  Renew / TopUp
                </Button>
              </Flex>
            </Box>
          ) : (
            <Loader />
          )}
        </>
      )}

      {/* Statement Tab — Claude: table format Date | Plan Name | Amount Paid | Payment Ref | RFX Added 25-Apr-2026 */}
      {activeTab === TAB_STATEMENT && (
        <Box px={5} pt={5} pb={8}>
          {statements.length === 0 ? (
            <Text fontSize="sm" color="gray.500">No payment records yet.</Text>
          ) : (
            <Box overflowX="auto">
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                <thead>
                  <tr style={{ background: "white", borderBottom: "2px solid #E9E4FF" }}>
                    {["Date", "Plan Name", "Amount Paid", "Payment Ref", "RFX Added"].map(h => (
                      <th key={h} style={{ padding: "8px 10px", textAlign: "left", fontWeight: 600, color: "#0E122F", whiteSpace: "nowrap" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {statements.map((s: any, i: number) => (
                    <tr key={i} style={{ borderBottom: "1px solid #F3F0FF", background: i % 2 === 0 ? "white" : "#FAFAFA" }}>
                      <td style={{ padding: "8px 10px", whiteSpace: "nowrap" }}>{s.date ? new Date(s.date).toLocaleDateString() : "—"}</td>
                      <td style={{ padding: "8px 10px" }}>{s.planName || "—"}</td>
                      <td style={{ padding: "8px 10px", whiteSpace: "nowrap" }}>{s.currency ? `${s.currency} ` : ""}{s.paidAmount ?? "—"}</td>
                      <td style={{ padding: "8px 10px" }}>{s.paymentReference || "—"}</td>
                      <td style={{ padding: "8px 10px" }}>{s.rfxAdded ?? "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Subscription;
